import Api from '.';
import { endpoints } from './endpoints';

export default class UserApi extends Api {

    getUsers(data) {
        let url = this.buildUrl(endpoints.user.getUser)

        return this.fetch(url, "GET").then(response => response);
    }

    myzone(data) {
        let url = this.buildUrl(endpoints.login.myzone)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    PMSDistibutorLogin(data) {
        let url = this.buildUrl(endpoints.login.PMSDistibutorLogin)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    PMSGenerateOtp(data) {
        let url = this.buildUrl(endpoints.login.PMSGenerateOtp)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    ResetForgetPassword(data) {
        let url = this.buildUrl(endpoints.login.ResetForgetPassword)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    AIFDistibutorLogin(data) {
        let url = this.buildUrl(endpoints.login.AIFDistibutorLogin)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    ResetForgetPasswordAIF(data) {
        let url = this.buildUrl(endpoints.login.ResetForgetPasswordAIF)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    userLog(data) {
        let url = this.buildUrl(endpoints.login.userlog)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    validateUser(data) {
        let url = this.buildUrl(endpoints.login.validateUser)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    validateToken() {
        let url = this.buildUrl(endpoints.user.validateToken)
        return this.fetch(url, "GET").then(response => response);
    }

    logout() {
        let url = this.buildUrl(endpoints.login.logout)
        return this.fetch(url, "GET").then(response => response);
    }

    logoutNew() {
        let url = this.buildUrl(endpoints.login.logoutNew)
        return this.fetch(url, "GET").then(response => response);
    }

    loginAttempt(data) {
        let url = this.buildUrl(endpoints.login.loginAttempt)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    getStratergy(data) {
        let url = this.buildUrl(endpoints.login.getStratergy)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    reportSend(data) {
        let url = this.buildUrl(endpoints.login.reportSend)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    accountPerformance(data) {
        let url = this.buildUrl(endpoints.login.GetAccountPerformance)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetCorporateAction(data) {
        let url = this.buildUrl(endpoints.login.GetCorporateAction)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }


    GetDebitNote(data) {
        let url = this.buildUrl(endpoints.login.GetDebitNote)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetCapitalMovement(data) {
        let url = this.buildUrl(endpoints.login.GetCapitalMovement)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetTaxaibleGain(data) {
        let url = this.buildUrl(endpoints.login.GetTaxaibleGain)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetHoldingStatement(data) {
        let url = this.buildUrl(endpoints.login.GetHoldingStatement)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    bitlyLink(data) {
        let url = this.buildUrl(endpoints.login.bitlyLink)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetAuditReportYears(data) {
        let url = this.buildUrl(endpoints.login.GetAuditReportYears)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetAuditReport(data) {
        let url = this.buildUrl(endpoints.login.GetAuditReport)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetQueryCategory(data) {
        let url = this.buildUrl(endpoints.login.GetQueryCategory)
        return this.fetchNormal(url, "GET", null, data).then(response => response)
    }
    GetQuerySubCategory(data) {
        let url = this.buildUrl(endpoints.login.GetQuerySubCategory)
        return this.fetchNormal(url, "GET", null, data).then(response => response)
    }
    RaiseQueryClientMF(data) {
        let url = this.buildUrl(endpoints.login.RaiseQueryClientMF)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    RaiseQueryClientPMS(data) {
        let url = this.buildUrl(endpoints.login.RaiseQueryClientPMS)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    RaiseQueryClientAIF(data) {
        let url = this.buildUrl(endpoints.login.RaiseQueryClientAIF)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    RaiseQuery(data) {
        let url = this.buildUrl(endpoints.login.RaiseQuery)
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetAuditReportStratergy(data) {
        let url = this.buildUrl(endpoints.login.GetAuditStratergy)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetAccountStatement(data) {
        let url = this.buildUrl(endpoints.login.GetAccountStatement)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetMFAccountStatement(data) {
        let url = this.buildUrl(endpoints.login.GetMFAccountStatement)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    ClientAIF(data) {
        let url = this.buildUrl(endpoints.login.ClientAIF)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    ClientMF(data) {
        let url = this.buildUrl(endpoints.login.ClientMF)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetMFcapitalGainLoss(data) {
        let url = this.buildUrl(endpoints.login.GetMFcapitalGainLoss)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetRaiseQuery(data) {
        let url = this.buildUrl(endpoints.login.GetRaiseQuery)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    //admin module
    RaiseQueryAdminRole(data) {
        let url = this.buildUrl(endpoints.login.RaiseQueryAdminRole)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }





    //pms audit report api
    PMSGetAuditReportStrategy(data) {
        let url = this.buildUrl(endpoints.login.PMSGetAuditReportStrategy)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    GetAccountPerformanceGroupwis(data) {
        let url = this.buildUrl(endpoints.login.GetAccountPerformanceGroupwis)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    reports(data) {
        let url = this.buildUrl(endpoints.reports.GetAccountPerformance)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    GetFractionLedger(data) {
        let url = this.buildUrl(endpoints.reports.GetFractionLedger)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)

    }
    PMSRealisedCapitalGainLossReport(data) {
        let url = this.buildUrl(endpoints.reports.PMSRealisedCapitalGainLossReport)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
}